import { baseURL } from '@/utils/baseConfig';
import { SSE } from 'sse.js';
import { getToken } from '@/utils/auth';
import request from '@/utils/request';

export const getAgentBootstrap = (code, instanceId) => {
  return request.get(`/app-api/therapy/agent/${code}/${instanceId}/bootstrap`, {
    timeout: 30000
  });
};

export const streamAgent = (code, instanceId, data) => {
  return new SSE(baseURL + `/app-api/therapy/agent/${code}/${instanceId}/stream`, {
    method: 'POST',
    headers: {
      accept: 'text/event-stream',
      'Content-Type': 'application/json',
      'tenant-id': 1,
      Authorization: `Bearer ${getToken()}`
    },
    payload: JSON.stringify(data)
  });
};
